import { type ReactNode } from 'react'
import { useHasSecurityGroup } from '@m3-tech/boss-core'
import { AccessDeniedPage } from '@m3-tech/boss-ui'

interface SecurityGroupGuardedRouteProps {
    securityGroupId: number
    children: ReactNode
    fallback?: ReactNode
}

export function SecurityGroupGuardedRoute({
    securityGroupId,
    children,
    fallback,
}: SecurityGroupGuardedRouteProps) {
    const hasGroup = useHasSecurityGroup(securityGroupId)
    if (!hasGroup) return fallback ?? <AccessDeniedPage />
    return <>{children}</>
}
